import Microgame from '../engine/Microgame.js';

export default class CrackGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Craque !`, en: `Crack!`, es: `¡Rompe!` },
            controls: { fr: `Appuie de manière frénétique sur l'œuf`, en: `Tap frantically on the egg`, es: `Toca frenéticamente el huevo` },
            objective: { fr: `Détruis l'objet à la force de tes clics`, en: `Destroy the object with pure tapping force`, es: `Destruye el objeto tocándolo con fuerza` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--secondary-color)" stroke-width="2"><path d="M12 22a8 8 0 0 0 8-8c0-5-5-12-8-12S4 9 4 14a8 8 0 0 0 8 8z"/><path d="m14 2-2 4 3 3-4 3 2 4"/></svg>`,
            actions: [
                { type: 'tap', x: 50, y: 50, duration: 120 },
                { type: 'wait', duration: 110 },
                { type: 'tap', x: 50, y: 50, duration: 120 },
                { type: 'wait', duration: 110 },
                { type: 'tap', x: 50, y: 50, duration: 120 },
                { type: 'wait', duration: 110 },
                { type: 'tap', x: 50, y: 50, duration: 120 },
                { type: 'wait', duration: 110 },
                { type: 'tap', x: 50, y: 50, duration: 120 },
                { type: 'wait', duration: 320 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.target = null;
        this.cracks = [];
        this.tapCount = 0;
        this.requiredTaps = 10;
        this.isBroken = false;

        const speedMult = engine.speedMultiplier || 1.0;
        // Equivalent to 3.7 speed at max 4.0
        const adjustedSpeed = 1 + (speedMult - 1) * (2.7 / 3);
        this.duration = 3000 * (speedMult / adjustedSpeed);
    }

    setup() {
        this.engine.ui.instruction.textContent = "CRACK!";
        this.requiredTaps = Math.floor(Math.random() * 3) + 5; // 5-7 taps

        // The Object (Egg/Safe/Geode)
        this.target = document.createElement('div');
        this.target.style.position = 'absolute';
        this.target.style.top = '50%';
        this.target.style.left = '50%';
        this.target.style.transform = 'translate(-50%, -50%)';
        this.target.style.width = '150px';
        this.target.style.height = '200px';
        this.target.style.background = this.primaryColor;
        this.target.style.borderRadius = '50% 50% 40% 40%'; // Egg shape
        this.target.style.border = '5px solid #fff';
        this.target.style.boxShadow = `0 0 20px ${this.primaryColor}`;
        this.target.style.cursor = 'pointer';
        this.target.style.overflow = 'hidden';
        this.container.appendChild(this.target);

        // Add some "shine"
        const shine = document.createElement('div');
        shine.style.position = 'absolute';
        shine.style.top = '20px';
        shine.style.left = '30px';
        shine.style.width = '40px';
        shine.style.height = '60px';
        shine.style.background = 'rgba(255, 255, 255, 0.2)';
        shine.style.borderRadius = '50%';
        shine.style.transform = 'rotate(-20deg)';
        this.target.appendChild(shine);

        this.onTap = this.onTap.bind(this);
        this.target.addEventListener('pointerdown', this.onTap);
    }

    onTap(e) {
        if (!this.active || this.isBroken) return;

        this.tapCount++;

        // Visual feedback (shake)
        this.target.animate([
            { transform: 'translate(-50%, -50%) rotate(0deg)' },
            { transform: 'translate(-52%, -50%) rotate(-5deg)' },
            { transform: 'translate(-48%, -50%) rotate(5deg)' },
            { transform: 'translate(-50%, -50%) rotate(0deg)' }
        ], {
            duration: 100,
            easing: 'ease-in-out'
        });

        // Add crack visual
        this.addCrack(e.offsetX, e.offsetY);

        if (this.tapCount >= this.requiredTaps) {
            this.breakOpen();
        }
    }

    addCrack(x, y) {
        const crack = document.createElement('div');
        crack.style.position = 'absolute';
        crack.style.left = `${x}px`;
        crack.style.top = `${y}px`;
        crack.style.width = '40px';
        crack.style.height = '2px';
        crack.style.background = this.secondaryColor;
        crack.style.transform = `translate(-50%, -50%) rotate(${Math.random() * 360}deg)`;
        crack.style.zIndex = '5';
        this.target.appendChild(crack);

        // Cross crack
        const crack2 = document.createElement('div');
        crack2.style.position = 'absolute';
        crack2.style.left = `${x}px`;
        crack2.style.top = `${y}px`;
        crack2.style.width = '30px';
        crack2.style.height = '1px';
        crack2.style.background = this.secondaryColor;
        crack2.style.transform = `translate(-50%, -50%) rotate(${Math.random() * 360}deg)`;
        crack2.style.zIndex = '5';
        this.target.appendChild(crack2);
    }

    breakOpen() {
        this.isBroken = true;

        // Shatter effect
        this.target.style.background = '#000';
        this.target.style.border = 'none';
        this.target.innerHTML = ''; // Clear cracks

        // Reveal prize
        const prize = document.createElement('div');
        prize.textContent = '💎';
        prize.style.fontSize = '80px';
        prize.style.position = 'absolute';
        prize.style.top = '50%';
        prize.style.left = '50%';
        prize.style.transform = 'translate(-50%, -50%) scale(0)';
        prize.style.transition = 'transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)';
        this.container.appendChild(prize);

        // Animate prize
        requestAnimationFrame(() => {
            prize.style.transform = 'translate(-50%, -50%) scale(1.5)';
        });

        // Particles
        for (let i = 0; i < 10; i++) {
            const p = document.createElement('div');
            p.style.position = 'absolute';
            p.style.left = '50%';
            p.style.top = '50%';
            p.style.width = '10px';
            p.style.height = '10px';
            p.style.background = '#fff';
            p.style.borderRadius = '50%';
            this.container.appendChild(p);

            const angle = Math.random() * Math.PI * 2;
            const dist = 100 + Math.random() * 100;

            p.animate([
                { transform: 'translate(-50%, -50%) scale(1)', opacity: 1 },
                { transform: `translate(calc(-50% + ${Math.cos(angle) * dist}px), calc(-50% + ${Math.sin(angle) * dist}px)) scale(0)`, opacity: 0 }
            ], {
                duration: 500,
                easing: 'ease-out',
                fill: 'forwards'
            });
        }

        this.win();
    }

    cleanup() {
        super.cleanup();
        if (this.target) {
            this.target.removeEventListener('pointerdown', this.onTap);
        }
    }
}
